import { render, staticRenderFns } from "./strokeOrderInfo.vue?vue&type=template&id=0487b6bd&scoped=true&"
import script from "./strokeOrderInfo.vue?vue&type=script&lang=js&"
export * from "./strokeOrderInfo.vue?vue&type=script&lang=js&"
import style0 from "./strokeOrderInfo.vue?vue&type=style&index=0&id=0487b6bd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0487b6bd",
  null
  
)

export default component.exports